import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { detect } from 'detect-browser';

import { Form, Checkbox, Image } from 'semantic-ui-react';

import { LoginTemplate, ButtonLink, Button, Logo } from 'components';
// import Recaptcha from 'components';

import * as commonVar from 'libs/commonVar';

import styles from './Login.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class Login extends Component {
  render() {
    const {
      isLoading,
      pending,
      visibleCaptcha,
      visibleModal,
      login,
      loginResult,
      loginMessage,
      onCloseModal,
      handleChange,
      handleKeyPress,
      handleCheckbox,
      signIn,
      noActiveLogin,
      reSendMail,
      saveEmail,
      saveCheck
    } = this.props;

    // 국제화 처리
    const { formatMessage } = this.props.intl;

    // 브라우저 버전 체크
    const browser = detect();

    return (
      <LoginTemplate isHideLogo loginPage>
        {browser.name !== 'chrome' && (
          <div className="browserInfo" title="Chrome Download">
            <a
              href={
                commonVar.isJapan === 1
                  ? 'https://www.google.com/intl/ja_ALL/chrome/'
                  : 'https://www.google.com/intl/ko_ALL/chrome/'
              }
              target="_blank">
              <image className={cx('mfLogo noVersion white')} />
              {defineMessages(formatMessage({ id: 'Login_7', defaultMessage: '에 최적화 브라우저는 Chrome 입니다.' }))}
            </a>
          </div>
        )}
        <div className={cx('loginPage')}>
          <div className={cx('login-info')}>
            <Image className={cx('white')} src="/img/logo/login_logo.png" />
            <div className={cx('login-info-main-text')}>
              {defineMessages(formatMessage({ id: 'Intro_26', defaultMessage: '"보안의 시작과 끝은 사람"' }))}
            </div>
            <div className={cx('login-info-sub-text')}>
              <div>{defineMessages(formatMessage({ id: 'Login_8', defaultMessage: '악성메일 모의 테스트로' }))}</div>
              <div>
                {defineMessages(formatMessage({ id: 'Login_9', defaultMessage: '보안 인식 수준을 점검하세요.' }))}
              </div>
            </div>
          </div>
          <div className={cx('login-form')}>
            <Form autoComplete="new-password">
              <div className={cx('wrap-input')}>
                <Form.Input
                  className={cx('login-input')}
                  type="text"
                  name="userEmail"
                  placeholder={defineMessages(formatMessage({ id: 'Login_1', defaultMessage: '이메일' }))}
                  onChange={handleChange}
                  onKeyPress={handleKeyPress}
                  defaultValue={commonVar.isGs !== 1 ? saveEmail : ''}
                  error={loginResult > 1 ? true : false}
                  autoComplete="off"
                />
              </div>
              <div className={cx('wrap-input')}>
                <Form.Input
                  className={cx('login-input mt-20')}
                  type="password"
                  name="userPasswd"
                  placeholder={defineMessages(formatMessage({ id: 'Login_2', defaultMessage: '비밀번호' }))}
                  onChange={handleChange}
                  onKeyPress={handleKeyPress}
                  error={loginResult > 1 ? true : false}
                  autoComplete="new-password"
                />
              </div>
              <div className={cx('check-area')}>
                <Checkbox
                  label={
                    <label className={cx('dark-grey')}>
                      {defineMessages(formatMessage({ id: 'Login_3', defaultMessage: '이메일 저장' }))}
                    </label>
                  }
                  onChange={handleCheckbox}
                  defaultChecked={Boolean(saveCheck)}
                />
              </div>
              {/* google reCAPTCHA */}
              <div className={visibleCaptcha ? cx('') : cx('display-none')}>{/* <Recaptcha /> */}</div>
              {/* 로그인 실패시 에러 메세지 */}
              <div className={cx('error-message')}>{loginResult > 1 && loginMessage}</div>
              {/* 로그인 버튼 */}
              <div className={cx('button-area')}>
                <Button className={cx('bt-login')} loading={pending} onClick={signIn}>
                  {defineMessages(formatMessage({ id: 'Login_6', defaultMessage: '로그인' }))}
                </Button>
              </div>
            </Form>

            {/* 서비스 가입 / 비밀번호 찾기 영역 */}
            <div className={cx('extra-area')}>
              {/* 서비스 가입 - 구축형의 경우 서비스 가입 제한*/}
              {commonVar.isSaas === 1 && (
                <div className={cx('extra-inner')}>
                  <ButtonLink
                    activeOnlyWhenExact={false}
                    to="/register"
                    label={defineMessages(formatMessage({ id: 'Login_4', defaultMessage: '서비스 가입' }))}
                  />
                </div>
              )}
              {commonVar.isSaas === 1 && <div className={cx('dash')} />}
              {/* 비밀번호 찾기 */}
              <div className={cx('extra-inner')}>
                <ButtonLink
                  activeOnlyWhenExact={false}
                  to="/login/passwdReset"
                  label={defineMessages(formatMessage({ id: 'Login_5', defaultMessage: '비밀번호 찾기' }))}
                />
              </div>
            </div>
          </div>
        </div>
      </LoginTemplate>
    );
  }
}

export default injectIntl(Login);



// WEBPACK FOOTER //
// ./src/script/components/login/Login.js